import { StateService } from './../../services/state.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Notiz } from 'sharedTypes/notiz';
import { FirebaseService } from 'src/app/services/firebase.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
    selector: 'app-edit-notiz',
    templateUrl: './edit-notiz.component.html',
    styleUrls: ['./edit-notiz.component.scss'],
    standalone: false,
})
export class EditNotizComponent implements OnInit {
    savedNotiz = new Notiz();
    constructor(
        public glo: GlobalService,
        private firebaseService: FirebaseService,
        public dialogRef: MatDialogRef<EditNotizComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { notiz: Notiz; standAlone: boolean; onlyText: boolean },
    ) {}

    ngOnInit(): void {
        this.savedNotiz = JSON.parse(JSON.stringify(this.data.notiz));
    }

    async saveNotiz() {
        if (this.data.standAlone) {
            this.dialogRef.close(this.data.notiz);
            return;
        }
        if (this.data.notiz.id) {
            await this.firebaseService.updateNotiz(this.data.notiz, this.savedNotiz);
        } else {
            await this.firebaseService.createNotiz(this.data.notiz);
        }
        this.dialogRef.close();
    }
}
